import { IconButton, Tooltip } from "@mui/material";
import React, { useContext, useEffect } from "react";
import HomeIcon from "@mui/icons-material/Home";
import { useTranslation } from "react-i18next";
import AppContext from "../../../../Contexts/AppContext";
import { AOIService } from "../../../../../services/MapCore/AOIService";

export const CenterAoiControl = ({ map }) => {
  const { t } = useTranslation("main");
  const { aoiExtent } = useContext(AppContext);

  const centerMap = async () => {
    AOIService.center_map_from_extent_smoothly(map, aoiExtent);
  };

  return (
    <Tooltip title={t("center_aoi")}>
      <IconButton onClick={centerMap} className="mapButton">
        <HomeIcon />
      </IconButton>
    </Tooltip>
  );
};
